import type { FaireProductEntity } from "../../entity_types/product";

export const p_m357kpvrd3: FaireProductEntity = {
  token: "p_m357kpvrd3",
  type: "product",
  name: "18K Gold Plated Waterproof Stainless Steel Mama Necklace - 7780",
  brandToken: "b_4zc36e4kj9",
  brandName: "Mia Accessories",
  imageUrl:
    "https://cdn.faire.com/fastly/71aedc9d8690849d8dba94ecf8fed026e3fe4789af08656663f3f0629343fbea.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bc1093b61b04bf15678285ac1de9a7d2b135b9f43e5d9904a113de865667b47d.jpeg",
    "https://cdn.faire.com/fastly/c2f9994982bd53bcb85958128d7f72ba1e1a66e910f4276b7f81a0557c4d2c2d.jpeg",
    "https://cdn.faire.com/fastly/13f114b9ee3f1bb055ab526cfa01e40f163890beb7179f1ff804c8d1b3e188c2.jpeg",
    "https://cdn.faire.com/fastly/7ccff811065b578bd0a69265b8b22bc9eaa572f9edd1dd149a0a22e8bb1c94ee.jpeg",
  ],
  priceDollars: 7.97,
  description:
    '18K Gold Dipped Stainless Steel Dainty Chain Necklace.\n16" L + 2" extender.\n\n\n\n\nThis item is hypoallergenic, waterproof and tarnish-resistant.\n\n*To prolong the shine and finish of the gold plating, contact with chemicals such as lotions, perfumes, and cleaning products should be avoided.*\n\n\n\nMama Necklace | Dainty Chain Necklace | Real Gold Dipped Necklace | Real Gold Plated Necklace | Waterproof & Sweatproof Necklace | Layering Necklace | Simple Gold Necklace\n',
  tags: [],
  msrpDollars: 31.87,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:59.195Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
